import { useState } from "react";

import { SearchConditionItem, SettingUser } from "@/types/setting";

import { cn } from "@/libs/utils";

import { GetSearchConditionLiveTextSearch } from "@/services/Setting";

import CommonImg from "@/components/Common/Img";

import PinIconTrue from "@/assets/images/pin-icon-true.png";
import PinIconFalse from "@/assets/images/pin-icon-false.png";
import BlackChevronDownIcon from "@/assets/images/black-chevron-icon-down.png";
import BlackChevronUpIcon from "@/assets/images/black-chevron-icon-up.png";
import NoEntryIcon from "@/assets/images/no-entry-icon.png";
import TempProfile from "@/assets/images/LNB/temp-profile.jpg";
import CloseIcon from "@/assets/images/black-close-icon.png";
import BlackSearchIcon from "@/assets/images/black-search-icon.png";
import PlusIcon from "@/assets/images/plus-icon.png";

type Props = {
  itemIndex: number;
  item: SearchConditionItem;
  itemListLength: number;
  onChangeTitle: (value: string) => void;
  onDelete: () => void;
  onPin: () => void;
  onAddUser: (user: SettingUser) => void;
  onRemoveUser: (user: SettingUser) => void;
};
export default function CommonDialogKeywordGroupItem({
  itemIndex,
  item,
  itemListLength,
  onChangeTitle,
  onDelete,
  onPin,
  onAddUser,
  onRemoveUser,
}: Props) {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [isAdding, setAdding] = useState<boolean>(false);
  const [userList, setUserList] = useState<SettingUser[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  let debounceTimeout: any;

  const handleLiveSearch = async (value: string) => {
    try {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(async () => {
        const result = await GetSearchConditionLiveTextSearch(value);
        setUserList(result.data.pods[0].content);
      }, 100);
    } catch (e) {
    } finally {
    }
  };

  return (
    <div className="flex flex-col gap-[8px]">
      <div className="flex gap-[12px] items-center pt-[1px]">
        {item.pinned ? (
          <CommonImg src={PinIconTrue} alt="Pin" className="size-[20px]" />
        ) : (
          <CommonImg
            src={PinIconFalse}
            alt="Unpin"
            className="size-[20px] cursor-pointer"
            onClick={() => {
              onPin();
            }}
          />
        )}
        <input
          type="text"
          className="w-full p-[8px] text-sm font-semibold focus:outline-dark-red"
          placeholder="추가할 검색 조건 이름을 입력하세요"
          value={item.search_name}
          onChange={(e) => {
            onChangeTitle(e.target.value);
          }}
        />
        {isOpen ? (
          <CommonImg
            src={BlackChevronUpIcon}
            alt="Black Chevron Up"
            className="size-[16px] cursor-pointer"
            onClick={() => {
              setOpen((prev) => !prev);
            }}
          />
        ) : (
          <CommonImg
            src={BlackChevronDownIcon}
            alt="Black Chevron Down"
            className="size-[16px] cursor-pointer"
            onClick={() => {
              setOpen((prev) => !prev);
            }}
          />
        )}
        {item.pinned ? (
          <div className="size-[20px] min-w-[20px]" />
        ) : (
          <CommonImg
            src={NoEntryIcon}
            alt="Delete Keyword Group"
            className="size-[20px] cursor-pointer"
            onClick={() => {
              onDelete();
            }}
          />
        )}
      </div>
      {isOpen && (
        <div className="flex gap-[8px] flex-wrap">
          {item.users?.map((user, userIndex) => (
            <div
              key={userIndex}
              className="bg-dark-red-clear flex gap-[8px] items-center rounded-[20px] text-gray-A text-[12px] py-[6px] px-[8px]"
            >
              <CommonImg
                src={user.image_url ?? TempProfile}
                alt="Profile Image"
                className="rounded-[50px]"
              />
              <span>
                {user.last_name}
                {user.first_name}
              </span>
              <CommonImg
                src={CloseIcon}
                alt="Close"
                className="size-[4px] cursor-pointer"
                onClick={() => {
                  onRemoveUser(user);
                }}
              />
            </div>
          ))}
          {isAdding ? (
            <div className={cn("relative", { "z-10": !!userList })}>
              <div
                className="w-[100px] px-[10px] py-[6px] border-dark-red border-[1px] rounded-[20px] flex justify-between items-center"
                onBlur={() => {
                  let hideResult: any;
                  clearTimeout(hideResult);
                  hideResult = setTimeout(() => {
                    setUserList([]);
                  }, 100);
                }}
              >
                <input
                  type="text"
                  className={cn(
                    "w-full h-[14px] focus:outline-none text-[12px] font-semibold"
                  )}
                  value={searchText}
                  onFocus={(e) => {
                    handleLiveSearch(e.target.value);
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleLiveSearch(value);
                    setSearchText(value);
                  }}
                />
                <CommonImg
                  src={BlackSearchIcon}
                  alt="Search"
                  className="size-[16px]"
                />
              </div>
              {userList.length > 0 && (
                <div className="w-[100px] top-[10px] left-[0px] pt-[20px] z-[-1] absolute flex flex-col bg-white border-x-[1px] border-b-[1px] rounded-b-[4px] text-[12px] font-bold">
                  <div className="max-h-[100px] overflow-auto">
                    {userList.map((user, userIndex) => (
                      <div
                        key={userIndex}
                        onClick={() => {
                          onAddUser(user);
                          setSearchText("");
                          setAdding(false);
                        }}
                      >
                        <div className="p-[8px] flex gap-[8px] justify-center items-center hover:bg-gray-D cursor-pointer">
                          <div>
                            <CommonImg
                              src={TempProfile}
                              alt="Temp"
                              className="size-[18px]"
                            />
                          </div>
                          <div>
                            {user.last_name}
                            {user.first_name}
                          </div>
                        </div>
                        {userIndex < userList.length - 1 && <hr />}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              className="w-[100px] px-[8px] py-[6px] flex justify-center items-center rounded-[20px] border-[1px] border-gray-D cursor-pointer"
              onClick={() => {
                setAdding((prev) => !prev);
              }}
            >
              <CommonImg src={PlusIcon} alt="Plus" className="size-[12px]" />
            </div>
          )}
        </div>
      )}

      {itemIndex < itemListLength - 1 && <hr />}
    </div>
  );
}
